/**
 * The ABI fragments the browser writes through.
 *
 * Hand-trimmed rather than copied from the artifacts, and for viem that buys
 * something real: `as const` makes these literal types, so a mistyped function
 * name is a compile error rather than a runtime revert with the user's wallet
 * already open. The Go server takes the opposite approach for the opposite
 * reason — see scripts/sync-abis.sh.
 *
 * Only the write surface plus the two reads the payment flow needs. Everything
 * else the browser wants comes from the API, which reads it from the registry.
 */

export const erc20Abi = [
  {
    name: "balanceOf",
    type: "function",
    stateMutability: "view",
    inputs: [{ name: "owner", type: "address" }],
    outputs: [{ type: "uint256" }],
  },
  {
    name: "allowance",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" },
    ],
    outputs: [{ type: "uint256" }],
  },
  {
    name: "approve",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      { name: "spender", type: "address" },
      { name: "value", type: "uint256" },
    ],
    outputs: [{ type: "bool" }],
  },
] as const;

/**
 * The three entry points, one per utility.
 *
 * Membership takes no amount: its price is an immutable on the contract, so
 * there is nothing for a caller to get wrong. The other two take one, which is
 * why the server holds them to the amount it quoted — see the note in
 * `AsetquHubUtilities.sol` about what an underpayment buys.
 */
export const membershipAbi = [
  {
    name: "activate",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [{ name: "referenceId", type: "bytes32" }],
    outputs: [],
  },
  {
    name: "membershipExpiry",
    type: "function",
    stateMutability: "view",
    inputs: [{ name: "member", type: "address" }],
    outputs: [{ type: "uint64" }],
  },
  {
    name: "PRICE",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [{ type: "uint256" }],
  },
] as const;

export const evoucherAbi = [
  {
    name: "redeem",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      { name: "referenceId", type: "bytes32" },
      { name: "voucherId", type: "bytes32" },
      { name: "amount", type: "uint256" },
    ],
    outputs: [],
  },
] as const;

export const catalogAbi = [
  {
    name: "purchase",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      { name: "referenceId", type: "bytes32" },
      { name: "productId", type: "bytes32" },
      { name: "amount", type: "uint256" },
    ],
    outputs: [],
  },
] as const;
